import ProposalHeader from './ProposalHeaderBar';

export default ProposalHeader;
